import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Users() {
  const [users, setUsers]     = useState([]);
  const [me, setMe]           = useState(null);
  const [form, setForm]       = useState({ username: '', password: '', role: 'user' });
  const [showForm, setShowForm] = useState(false);
  const [msg, setMsg]         = useState('');
  const [error, setError]     = useState('');
  const [saving, setSaving]   = useState(false);

  const flash = (m, isErr = false) => {
    if (isErr) setError(m); else setMsg(m);
    setTimeout(() => { setMsg(''); setError(''); }, 3000);
  };

  const load = async () => {
    try {
      const [u, m] = await Promise.all([api.get('/auth/users'), api.get('/auth/me')]);
      setUsers(u.data); setMe(m.data);
    } catch (e) { flash(e.response?.data?.error || 'Load failed', true); }
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.username || !form.password) return setError('Username and password required');
    setSaving(true);
    try {
      await api.post('/auth/register', form);
      flash(`User "${form.username}" created!`);
      setForm({ username: '', password: '', role: 'user' });
      setShowForm(false);
      await load();
    } catch (e) { setError(e.response?.data?.error || 'Failed'); }
    finally { setSaving(false); }
  };

  const deleteUser = async (u) => {
    if (!window.confirm(`Delete user "${u.username}"? All their numbers and data will be deleted.`)) return;
    try {
      await api.delete(`/auth/users/${u.id}`);
      flash('User deleted');
      await load();
    } catch (e) { flash(e.response?.data?.error || 'Delete failed', true); }
  };

  if (me && me.role !== 'admin') {
    return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)' }}>Admin access only.</div>;
  }

  return (
    <div style={{ padding: '20px 16px', maxWidth: 640, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: 'var(--mono)', fontSize: 13, letterSpacing: '0.06em', color: 'var(--text2)', margin: 0 }}>
          👥 USER MANAGEMENT
        </h2>
        <button onClick={() => setShowForm(s => !s)} className="btn-primary" style={{ fontSize: 13 }}>
          {showForm ? 'Cancel' : '+ Add User'}
        </button>
      </div>

      {msg   && <div style={fs('ok')}>{msg}</div>}
      {error && <div style={fs('err')}>{error}</div>}

      {showForm && (
        <div className="card" style={{ marginBottom: 20, border: '1px solid var(--accent)' }}>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--accent)', marginBottom: 16 }}>// NEW USER</div>
          <div style={{ marginBottom: 12 }}>
            <label className="label">Username</label>
            <input value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} placeholder="john_doe" />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label className="label">Password</label>
            <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label className="label">Role</label>
            <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <button onClick={save} className="btn-primary" disabled={saving}>{saving ? 'Creating…' : 'Create User'}</button>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {users.map(u => (
          <div key={u.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontWeight: 600, fontSize: 14 }}>{u.username}</span>
                <span style={{
                  background: u.role === 'admin' ? 'rgba(79,209,197,0.15)' : 'var(--bg3)',
                  color: u.role === 'admin' ? 'var(--accent)' : 'var(--text3)',
                  fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 4,
                  fontFamily: 'var(--mono)', border: `1px solid ${u.role === 'admin' ? 'var(--accent)' : 'var(--border)'}`,
                }}>{u.role.toUpperCase()}</span>
                {me?.id === u.id && (
                  <span style={{ fontSize: 10, color: 'var(--text3)' }}>(you)</span>
                )}
              </div>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 3 }}>
                Created: {new Date(u.created_at).toLocaleDateString()}
              </div>
            </div>
            {me?.id !== u.id && (
              <button onClick={() => deleteUser(u)} className="btn-ghost"
                style={{ fontSize: 12, color: 'var(--danger)' }}>
                🗑 Delete
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function fs(type) {
  return {
    padding: '10px 14px', borderRadius: 'var(--r-sm)', marginBottom: 14, fontSize: 13,
    background: type === 'ok' ? 'rgba(79,209,197,0.1)' : 'rgba(239,68,68,0.1)',
    border: `1px solid ${type === 'ok' ? 'var(--accent)' : 'var(--danger)'}`,
    color: type === 'ok' ? 'var(--accent)' : 'var(--danger)',
  };
}
